const UserOnlineStatus = {
  ONLINE: "ONLINE",
	OFFLINE: "OFFLINE"
};

export default UserOnlineStatus;
